'use strict';

var React = require('react');

var SvgOrganizationIcon = function SvgOrganizationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 9.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6.5a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.5 5.25c0-.966.784-1.75 1.75-1.75h6.25c.966 0 1.75.784 1.75 1.75v1.75h1.5c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 0 1-1.75 1.75h-9.5a1.75 1.75 0 0 1-1.75-1.75v-9.5Zm4.25 9.75h1.25v-1.25a.25.25 0 0 0-.25-.25h-.75a.25.25 0 0 0-.25.25v1.25Zm2.75 0v-1.25a1.75 1.75 0 0 0-1.75-1.75h-.75a1.75 1.75 0 0 0-1.75 1.75v1.25h-1a.25.25 0 0 1-.25-.25v-9.5a.25.25 0 0 1 .25-.25h6.25a.25.25 0 0 1 .25.25v9.5a.25.25 0 0 1-.25.25h-1Zm2.75-.25v-6.25h1.5a.25.25 0 0 1 .25.25v6a.25.25 0 0 1-.25.25h-1.518a1.72 1.72 0 0 0 .018-.25Z"
  }));
};
SvgOrganizationIcon.displayName = "OrganizationIcon";

exports.SvgOrganizationIcon = SvgOrganizationIcon;
